// Centro de Ajuda — guias por categoria, filtrados por perfil.
// roles: array de perfis que veem o guia. 'all' = todos.
// Cada artigo: { roles, q (título), intro (string|array de parágrafos), steps (array opcional) }

export const HELP_CATEGORIES = [
  {
    id: 'primeiros-passos',
    title: 'Primeiros Passos',
    icon: 'Compass',
    articles: [
      {
        roles: ['all'],
        q: 'Como me oriento no CRM?',
        intro: 'O menu lateral à esquerda dá acesso a tudo. As secções abrem em acordeão e o CRM lembra-se de onde estavas.',
        steps: [
          'Topo: Dashboard (visão geral) e Contratos Geral (lista de todos os contratos).',
          'LEADS: gerir e trabalhar leads (Leads Externas, Minha Pipeline, etc.).',
          'FERRAMENTAS: Calendário, Simulador de Energia e outras utilidades.',
          'Em baixo: o teu perfil e o Centro de Ajuda (onde estás agora).',
        ],
      },
      {
        roles: ['all'],
        q: 'O que vejo depende do meu perfil',
        intro: 'Cada função (Comercial, Angariador, Gestor, etc.) vê apenas as áreas e ações a que tem acesso. Se não vês um menu, é porque o teu perfil não tem essa permissão — fala com o teu Gestor se precisares.',
      },
    ],
  },
  {
    id: 'leads',
    title: 'Leads',
    icon: 'Users',
    articles: [
      {
        roles: ['all'],
        q: 'Qual a diferença entre "Leads Externas" e "Minha Pipeline"?',
        intro: [
          '“Leads Externas” é a lista completa de gestão das leads: criar, atribuir a comerciais, editar dados, mudar a origem, pedir assinatura, etc. É aqui que se administra tudo.',
          '“Minha Pipeline” é a tua ferramenta de trabalho diário: vês as leads em curso, contactas o cliente, reagendas, registas o estado e convertes em contrato com 1 clique. Serve para acompanhar o andamento.',
        ],
      },
      {
        roles: ['super_admin', 'gestor', 'admin', 'parceiro', 'comercial', 'chefe_equipa', 'angariador'],
        q: 'Como criar uma lead manualmente?',
        intro: 'Quando recebes um contacto (ex: pelo WhatsApp), regista-o assim:',
        steps: [
          'Vai a LEADS → Leads Externas (ou Minha Pipeline).',
          'Clica em "Nova Lead".',
          'Preenche nome, telemóvel e os dados disponíveis. Escolhe a Origem (ex: Call Center, Meta, Meu Cliente).',
          '(Opcional) Se tiveres permissão, escolhe logo o Comercial responsável.',
          'Guarda. A lead fica disponível para ser trabalhada.',
        ],
      },
      {
        roles: ['super_admin', 'gestor', 'admin'],
        q: 'Como atribuir ou distribuir leads aos comerciais?',
        intro: 'Há duas formas — individual ou em massa:',
        steps: [
          'Individual: abre a ficha da lead → painel "Atribuir Comercial" → escolhe o comercial → Guardar.',
          'Em massa: em Leads Externas, marca as caixinhas das leads por atribuir (só aparecem em leads sem comercial).',
          'Clica em "Atribuir Comercial" na barra que surge.',
          'Escolhe "Um comercial" (todas para o mesmo) ou "Distribuir" (round-robin entre vários comerciais).',
          'Confirma. Os comerciais são notificados automaticamente.',
        ],
      },
      {
        roles: ['super_admin', 'gestor', 'admin'],
        q: 'Como mudar a origem de uma lead já criada?',
        steps: [
          'Em Leads Externas, clica no lápis (Editar) da lead.',
          'Altera o campo "Origem da Lead".',
          'Guarda.',
        ],
      },
      {
        roles: ['comercial', 'chefe_equipa', 'super_admin', 'gestor', 'admin', 'parceiro', 'backoffice'],
        q: 'Como trabalhar e converter uma lead em contrato?',
        steps: [
          'Vai a LEADS → Minha Pipeline.',
          'Abre a lead, contacta o cliente e atualiza o estado (Em Contacto, Reagendada, etc.).',
          'Quando o cliente fecha, usa o botão de converter para criar o contrato com 1 clique.',
          'Após a conversão é criado automaticamente um acompanhamento (check-in D+45).',
        ],
      },
      {
        roles: ['super_admin', 'gestor', 'admin'],
        q: 'Como filtrar leads por origem, parceiro ou comercial?',
        intro: 'Em Leads Externas tens filtros por Estado e Origem. Na Minha Pipeline tens também filtros por Parceiro e Comercial (e a coluna "Comercial" mostra o responsável de cada lead).',
      },
    ],
  },
  {
    id: 'assinaturas',
    title: 'Assinaturas Remotas',
    icon: 'PenLine',
    articles: [
      {
        roles: ['super_admin', 'gestor', 'admin'],
        q: 'Como configurar um modelo assinável (ex: Autorização de Contacto)?',
        intro: 'Configura-se uma vez por documento e fica guardado.',
        steps: [
          'Vai a SUPORTE → Base de Conhecimento.',
          'No documento PDF (ex: LEAD ENDESA), clica no ícone da caneta ("Configurar assinatura").',
          'No editor, liga só os campos que o documento precisa (Nome, Contacto, Localidade, Dia, Mês, Ano, Assinatura).',
          'Arrasta cada etiqueta para a posição certa sobre o documento (o canto inferior direito redimensiona).',
          'Guarda. O documento fica marcado como "Assinável".',
        ],
      },
      {
        roles: ['super_admin', 'gestor', 'admin', 'comercial', 'chefe_equipa', 'parceiro', 'backoffice'],
        q: 'Como enviar um documento para o cliente assinar no telemóvel?',
        steps: [
          'Abre a ficha da lead → painel "Pedir Assinatura".',
          'Escolhe o modelo (ex: LEAD ENDESA). O nome e contacto do cliente são pré-preenchidos.',
          'Clica em "Gerar Link de Assinatura".',
          'Partilha com o cliente pelo botão "WhatsApp" ou "Copiar link".',
          'O cliente abre no telemóvel, lê o documento, aceita o consentimento RGPD e assina com o dedo.',
        ],
      },
      {
        roles: ['super_admin', 'gestor', 'admin', 'comercial', 'chefe_equipa', 'parceiro', 'backoffice'],
        q: 'Onde fica o documento depois de assinado?',
        intro: 'Recebes uma notificação (sino). Na ficha da lead → painel "Pedir Assinatura", o pedido passa a "Assinado ✅" com a data e aparece um botão para descarregar o PDF assinado. Nota: recarrega a página para veres o estado atualizado, já que o cliente assina noutro dispositivo.',
      },
    ],
  },
  {
    id: 'base-conhecimento',
    title: 'Base de Conhecimento',
    icon: 'BookOpen',
    articles: [
      {
        roles: ['all'],
        q: 'Como consultar e descarregar tarifários e documentos?',
        steps: [
          'Vai a SUPORTE → Base de Conhecimento.',
          'Abre a empresa e o tipo de cliente para ver os documentos.',
          'Clica no ícone de download para descarregar o ficheiro.',
        ],
      },
      {
        roles: ['super_admin', 'gestor', 'admin'],
        q: 'Como carregar novos tarifários?',
        steps: [
          'Em Base de Conhecimento, clica em "Adicionar Ficheiro".',
          'Escolhe a empresa, o tipo de cliente e o(s) ficheiro(s).',
          'Cada documento mostra a data/hora de carregamento e quem carregou, para saberes se está atualizado.',
        ],
      },
      {
        roles: ['super_admin', 'gestor', 'admin'],
        q: 'Como apagar vários documentos de uma vez?',
        steps: [
          'Marca as caixinhas dos documentos a apagar.',
          'Clica em "Apagar selecionados" na barra vermelha que surge no topo.',
          'Confirma. Dica: mantém sempre as Autorizações de Contacto (têm o selo "Assinável").',
        ],
      },
    ],
  },
  {
    id: 'contratos',
    title: 'Contratos',
    icon: 'FileText',
    articles: [
      {
        roles: ['all'],
        q: 'Onde vejo todos os contratos?',
        intro: 'No topo do menu, em "Contratos Geral", tens a lista completa com pesquisa e filtros. Cada contrato mostra o comercial responsável.',
      },
      {
        roles: ['super_admin', 'gestor', 'admin', 'backoffice'],
        q: 'Como importar contratos a partir de Excel/CSV?',
        steps: [
          'Vai a LEADS → Importar (ou a área de importação de contratos).',
          'Carrega o ficheiro Excel/CSV com os contratos.',
          'Confirma o mapeamento das colunas e importa.',
        ],
      },
    ],
  },
  {
    id: 'financeiro',
    title: 'Financeiro',
    icon: 'Wallet',
    articles: [
      {
        roles: ['super_admin', 'gestor', 'admin', 'backoffice'],
        q: 'Onde acompanho autos, comissões e pagamentos?',
        intro: 'Na secção FINANCEIRO tens os autos, as comissões em cascata e os estados de pagamento. Os follow-ups de 1ª fatura mostram o comercial responsável de cada cliente.',
      },
    ],
  },
  {
    id: 'simulador',
    title: 'Simulador de Energia',
    icon: 'Calculator',
    articles: [
      {
        roles: ['super_admin', 'gestor', 'admin', 'comercial', 'chefe_equipa', 'parceiro'],
        q: 'Como fazer uma simulação e gerar proposta?',
        steps: [
          'Vai a FERRAMENTAS → Simulador Energia.',
          'Introduz os consumos/dados do cliente e escolhe os tarifários a comparar.',
          'Vê o comparativo e gera a proposta em PDF para o cliente.',
        ],
      },
    ],
  },
  {
    id: 'organizacao',
    title: 'Gestão & Organização',
    icon: 'UsersRound',
    articles: [
      {
        roles: ['super_admin', 'gestor', 'admin', 'parceiro', 'backoffice'],
        q: 'Como gerir utilizadores e parceiros?',
        intro: 'Na secção ORGANIZAÇÃO podes criar e gerir utilizadores, equipas e parceiros, conforme as tuas permissões.',
      },
      {
        roles: ['super_admin', 'gestor'],
        q: 'Como controlar permissões e o que cada perfil vê?',
        intro: 'O acesso é controlado por função (RBAC). Cada perfil só vê os menus e ações permitidos. Como Super Admin/Gestor podes ajustar permissões na gestão de utilizadores.',
      },
    ],
  },
];

export const articlesForRole = (role) =>
  HELP_CATEGORIES
    .map((cat) => ({
      ...cat,
      articles: cat.articles.filter((a) => a.roles.includes('all') || a.roles.includes(role)),
    }))
    .filter((cat) => cat.articles.length > 0);
